import { xhrApiClient } from '@/config/xhrApiClient'

const CheckUserKYCApplicationStatus = async (payload: any) => {
    const { data } = await xhrApiClient.get('/api/kyc-application', payload)
    return { data }
}

export default CheckUserKYCApplicationStatus
